import React from 'react'
import { motion } from 'motion/react'
import type { FieldValues } from '../../fieldTypes'

export function SkeletonShimmer({ values = {} }: { values?: FieldValues }) {
  const duration = values.duration ?? 1.5
  const delay1 = values.delay1 ?? 0.2
  const delay2 = values.delay2 ?? 0.4
  const delay3 = values.delay3 ?? 0.6

  return (
    <div className="flex items-center justify-center h-full p-4">
      <div className="w-full max-w-[200px] bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="relative h-20 bg-gray-200 overflow-hidden">
          <motion.div
            className="absolute inset-0 bg-gradient-to-r from-transparent via-white/60 to-transparent"
            animate={{ x: ['-100%', '100%'] }}
            transition={{ duration, repeat: Infinity, ease: 'linear' }}
          />
        </div>
        <div className="p-3 space-y-2">
          <div className="relative h-3 bg-gray-200 rounded w-3/4 overflow-hidden">
            <motion.div
              className="absolute inset-0 bg-gradient-to-r from-transparent via-white/60 to-transparent"
              animate={{ x: ['-100%', '100%'] }}
              transition={{ duration, repeat: Infinity, ease: 'linear', delay: delay1 }}
            />
          </div>
          <div className="relative h-2.5 bg-gray-100 rounded w-full overflow-hidden">
            <motion.div
              className="absolute inset-0 bg-gradient-to-r from-transparent via-white/60 to-transparent"
              animate={{ x: ['-100%', '100%'] }}
              transition={{ duration, repeat: Infinity, ease: 'linear', delay: delay2 }}
            />
          </div>
          <div className="relative h-2.5 bg-gray-100 rounded w-1/2 overflow-hidden">
            <motion.div
              className="absolute inset-0 bg-gradient-to-r from-transparent via-white/60 to-transparent"
              animate={{ x: ['-100%', '100%'] }}
              transition={{ duration, repeat: Infinity, ease: 'linear', delay: delay3 }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
